import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { formatDateTime } from 'utils/validations'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Field from 'component/utils/Field'
import Textarea from 'component/utils/TextArea'
import { Link } from 'react-router'

class SuggestionEditForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      dsAnswer: '',
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChangeAnswer = this.handleChangeAnswer.bind(this)
    this.setValueToField = this.setValueToField.bind(this)
  }

  componentDidMount() {
    const { onOpen, suggestion } = this.props

    const updatedSuggestion = { ...suggestion, inShow: 1 }
    delete updatedSuggestion.lsImages

    onOpen(updatedSuggestion)
  }

  isOutsideRange() {
    return false
  }

  setValueToField(field, value) {
    const { fields, values } = this.state

    fields[field].input.value = value
    values[field] = value

    this.setState({ fields, values })
  }

  handleChangeAnswer(event) {
    const { setValueToField } = this.props
    const { target } = event

    this.setState({ dsAnswer: target.value })
    setValueToField('dsAnswer', target.value)
  }

  handleSubmit(event) {
    event.preventDefault()

    const { onSubmit, values, suggestion, user } = this.props

    const updatedSuggestion = {
      ...suggestion,
      dsAnswer: values.dsAnswer,
      dtAnswer: moment(),
      cdLdapAnswer: user.username,
      inNotifyUser: 1,
      inShow: 1,
    }
    delete updatedSuggestion.lsImages

    onSubmit(updatedSuggestion)
  }

  renderImages(image, index) {
    if (image != null) {
      return <img src={image} alt='' key={index} />
    }
  }

  render() {
    const { translate, suggestion, fields } = this.props

    return (
      <form className='MenuSuggestionEditForm'>
        <Row>
          <Col
            xs={12}
            sm={10}
            md={6}
            className='col-md-offset-3 col-sm-offset-1 margin-top background-gray padding-double'
          >
            <Row>
              <Col xs={12} className='margin-bottom'>
                <legend className='no-margin-top'>
                  {formatDateTime(suggestion.dtInclusion)}
                </legend>
              </Col>
            </Row>

            <Row>
              <Col xs={12} className='margin-bottom font'>
                <span className='strong'>
                  {suggestion.cdLdap}
                  {suggestion.dsUser ? ` - ${suggestion.dsUser}` : ''}
                </span>
              </Col>
            </Row>

            <Row>
              <Col xs={12} className='margin-bottom'>
                <span className='strong'>
                  {suggestion.idBranch} - {suggestion.dsBranch}
                </span>
              </Col>
            </Row>

            <Row>
              <Col xs={12} className='margin-bottom'>
                <span className='strong'>{suggestion.dsMenu}</span>
              </Col>
            </Row>

            <Row>
              <Col xs={12} className='margin-bottom'>
                {suggestion.dsSuggestion}
              </Col>
            </Row>

            <Row>
              <Col xs={12} className='margin-bottom suggestion-images'>
                {suggestion.lsImages != null &&
                  suggestion.lsImages.map(this.renderImages)}
              </Col>
            </Row>

            {suggestion.dsAnswer === undefined && (
              <Row>
                <Col xs={12} md={12}>
                  <div className='custom-container'>
                    <Field
                      {...fields.dsAnswer}
                      error={translate(fields.dsAnswer.error)}
                    >
                      <Textarea
                        type='textarea'
                        id='dsAnswer'
                        name='dsAnswer'
                        value={this.state.dsAnswer}
                        {...fields.dsAnswer.input}
                        label={translate('suggestions.answer')}
                        onChange={this.handleChangeAnswer}
                        rows={3}
                        autoExpandable
                      />

                      <button
                        role='button'
                        type='button'
                        onClick={this.handleSubmit}
                        className='button button-primary'
                      >
                        {translate('send')}
                      </button>
                    </Field>
                  </div>
                </Col>
              </Row>
            )}

            {suggestion.dsAnswer != null && (
              <Row>
                <Col xs={12} className='margin-bottom'>
                  <legend className='no-margin-top'>
                    {translate('suggestions.dsAnswer')}
                  </legend>
                </Col>
                <Col xs={12} md={12}>
                  <span className='strong'>{suggestion.dsAnswer}</span>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            sm={10}
            md={6}
            className='col-md-offset-3 col-sm-offset-1 margin-top'
          >
            <Col
              xs={12}
              sm={6}
              md={4}
              className='col-md-offset-4 col-sm-offset-3 align-center'
            >
              <Link
                role='button'
                to='/suggestions'
                className='button-hollow button-hollow-primary button-full'
              >
                {translate('back_button_label')}
              </Link>
            </Col>
          </Col>
        </Row>
      </form>
    )
  }
}

SuggestionEditForm.propTypes = {
  fields: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  suggestion: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  onOpen: PropTypes.func.isRequired,
  setValueToField: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}

const fields = ['dsAnswer']

export default Form({ fields })(SuggestionEditForm)

export { SuggestionEditForm }
